import type { PropertyTabPropertyRecord } from '../types/tabs'
import type { PropertyLeadTimeContext } from '../types/utils'

export function getPropertyLeadDays(
  selected: PropertyTabPropertyRecord | null | undefined,
): number | null {
  const raw =
    selected?.lease_start_lead_days ??
    selected?.lease_start_lead_time ??
    selected?.company?.lease_start_lead_days
  const days = Number(raw)
  return Number.isFinite(days) && days > 0 ? days : null
}

export function getSelectedPropertyLeadDays(
  ctx: PropertyLeadTimeContext,
): number | null {
  const propertyId = String(ctx.propertyIdValue || '')
  const selected =
    ctx.propertyData ??
    (ctx.selectedPropertyData &&
    String(ctx.selectedPropertyData?.property_id ?? '') === propertyId
      ? ctx.selectedPropertyData
      : undefined) ??
    (ctx.propertyOptions.find((o) => String(o.value) === propertyId)?.data as
      | PropertyTabPropertyRecord
      | undefined) ??
    (ctx.fallbackProperty && String(ctx.fallbackProperty?.property_id ?? '') === propertyId
      ? ctx.fallbackProperty
      : undefined)
  return getPropertyLeadDays(selected)
}

export function isLeaseStartBeyondLeadTime(
  value: unknown,
  ctx: PropertyLeadTimeContext,
): boolean {
  const leadDays = getSelectedPropertyLeadDays(ctx)
  if (!leadDays || !value) return false
  const leaseDate = new Date(String(value))
  if (Number.isNaN(leaseDate.getTime())) return false
  const limit = new Date()
  limit.setHours(0, 0, 0, 0)
  limit.setDate(limit.getDate() + leadDays)
  leaseDate.setHours(0, 0, 0, 0)
  return leaseDate > limit
}
